import { MzChart } from './chart.component.js';

export * from './chart.component.js';

MzChart.define('mz-chart');

declare global {
  interface HTMLElementTagNameMap {
    'mz-chart': MzChart;
  }
}
